<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'DoAndWin',
};
</script>
<style lang="scss" scoped></style>
